/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useGetData, useResetData, useSetData } from '@/data/Data.hook';

const key = 'backUrl';

export const useSetBackUrl = (
  url: string | undefined | null,
  queries?: Record<string, string>
) => {
  const searchParams = useSearchParams();

  const queryCondition =
    !queries ||
    Object.entries(queries).every(
      ([key, value]) => searchParams?.get(key) === value
    );

  const setData = useSetData(key);
  const resetData = useResetData(key);
  useEffect(() => {
    if (url && queryCondition) setData(url);
    else resetData();
    return () => resetData();
  }, [url, queryCondition]);
};

export const useGetBackUrl = () => {
  const router = useRouter();
  const backUrl = useGetData(key);

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (backUrl) {
        router.replace(backUrl); // Replace the current history entry
        event.preventDefault(); // Prevent the default navigation behavior
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [router, backUrl]);

  return backUrl;
};
